import React from 'react'
import Header from '../Components/Header'
import PageLayout from '../Layouts/PageLayout';
import payment from '../data/payment.json';
import { useLanguage } from '../i18n/LanguageContext';


export default function Donation() {
    const { ui } = useLanguage().content;
    const t = ui.donation;
    const p = ui.payment;

    return (
        <PageLayout header={
            <Header title={t.title}>
                <p className="mt-2 text-xl text-primary italic font-serif">{t.subtitle}</p>
            </Header>
        }
        firstColumn={
            <div className="flex flex-col items-center gap-8 mt-8">
                <div className="w-[200px] h-[200px] bg-gradient-to-br from-secondary/30 to-bgMuted rounded-full flex items-center justify-center">
                    <img className="w-[120px] h-[120px]" src="/donation-thumbnail.png" alt={t.imageAlt}/>
                </div>
                <div className="text-center text-textDark">
                    <blockquote className="text-xl font-serif italic text-primary border-l-4 border-secondary pl-4 text-left">
                        {t.verse}
                    </blockquote>
                    <p className="text-sm text-accent mt-4">{t.verseSource}</p>
                </div>
            </div>
        }
        >
            <div className="md:col-span-2 flex flex-col gap-8">
                <div className="bg-bgMuted/50 rounded-xl p-6 shadow-sm">
                    <h3 className="font-serif font-bold text-2xl text-primary mb-6">{t.provideHeading}</h3>
                    <div className="grid md:grid-cols-2 gap-6">
                        {t.causes.map((cause) => (
                            <div key={cause.title} className="bg-white/50 rounded-lg p-4 border-l-4 border-secondary">
                                <h4 className="font-semibold text-lg text-textDark mb-2">{cause.title}</h4>
                                <p className="text-accent">{cause.text}</p>
                            </div>
                        ))}
                    </div>
                    <div className="mt-6 text-center">
                        <a href="https://www.facebook.com/share/p/1X9SatAEak/" target="_blank" rel="noopener noreferrer" className="text-primary underline hover:text-primaryLight">
                            {t.moreDetails}
                        </a>
                    </div>
                </div>
                
                <div className="bg-gradient-to-r from-primary/10 to-secondary/10 rounded-xl p-6 text-center border border-secondary/30">
                    <p className="text-2xl font-serif font-bold text-primary mb-2">{t.zakat}</p>
                    <p className="text-accent">{t.frequency}</p>
                </div>

                <div className="bg-bgMuted/50 rounded-xl p-6 shadow-sm">
                    <h3 className="font-serif font-bold text-2xl text-primary mb-6 text-center">{t.modeHeading}</h3>
                    <div className="grid md:grid-cols-2 gap-8">
                        <div className="bg-white rounded-lg p-6 shadow-md border border-secondary/20">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="w-12 h-12 bg-pink-500 rounded-lg flex items-center justify-center text-white font-bold text-xl">B</div>
                                <h4 className="font-bold text-xl text-textDark">{p.bkash}</h4>
                            </div>
                            <p className="text-2xl font-mono text-primary font-bold">{payment.bkashNumber}</p>
                            <p className="text-sm text-accent mt-1">{p.personal}</p>
                        </div>
                        
                        <div className="bg-white rounded-lg p-6 shadow-md border border-secondary/20">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center text-white font-bold text-xl">🏦</div>
                                <h4 className="font-bold text-xl text-textDark">{p.bankAccount}</h4>
                            </div>
                            <div className="space-y-2 text-textDark">
                                <p><span className="font-semibold">{p.bank}</span> {p.bankName}</p>
                                <p><span className="font-semibold">{p.accountNo}</span> <span className="font-mono text-primary">{payment.bankAccountNumber}</span></p>
                                <p><span className="font-semibold">{p.accountHolder}</span> {payment.bankAccountHolder}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </PageLayout>
    );
  };
